import React from "react";
import { FaStar } from "react-icons/fa";
import toast, { Toaster } from "react-hot-toast";

// ReviewModal component
const ReviewModal = ({ isOpen, onClose, onSubmit, booking }) => {
  const [title, setTitle] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [rating, setRating] = React.useState(0);
  const [hoverRating, setHoverRating] = React.useState(0);
  const [errorMsg, setErrorMsg] = React.useState("");

  React.useEffect(() => {
    if (isOpen) {
      setTitle("");
      setDescription("");
      setRating(0);
      setHoverRating(0);
      setErrorMsg("");
    }
    // Don't reset on modal close!
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await onSubmit({
        title,
        description,
        rating,
        bookingId: booking?._id,
      });
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.response?.data?.error || // <== add this line
        err?.message ||
        "Something went wrong while submitting.";

      setErrorMsg(message);
      toast.error(message, { duration: 5000 });
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <Toaster position="top-right" />
      <div className="bg-white rounded-md p-6 w-full max-w-md max-w-full mx-4 sm:mx-auto sm:max-w-md">
      <h2 className="text-xl font-semibold mb-4 text-center">
          Add Review & Rating
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="title" className="block mb-1 font-medium">
              Review Title
            </label>
            <input
              id="title"
              type="text"
              maxLength={100}
              required
              placeholder="Enter review title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2"
            />
          </div>

          <div>
            <label htmlFor="description" className="block mb-1 font-medium">
              Review Description
            </label>
            <textarea
              id="description"
              rows={4}
              maxLength={500}
              required
              placeholder="Write your review here"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2 resize-none"
            />
          </div>

          <div>
            <p className="mb-1 font-medium">Rating</p>
            <div className="flex space-x-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <FaStar
                  key={star}
                  size={28}
                  className={`cursor-pointer ${
                    (hoverRating || rating) >= star
                      ? "text-yellow-400"
                      : "text-gray-300"
                  }`}
                  onClick={() => setRating(star)}
                  onMouseEnter={() => setHoverRating(star)}
                  onMouseLeave={() => setHoverRating(0)}
                />
              ))}
            </div>
          </div>

          {errorMsg && (
            <p className="text-red-600 text-sm text-center mt-2">{errorMsg}</p>
          )}

          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!title || !description || rating === 0}
              className={`px-4 py-2 rounded text-white ${
                !title || !description || rating === 0
                  ? "bg-blue-300 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
              }`}
            >
              Submit Review
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReviewModal;
